'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Checkbox_module = require('../styles/Checkbox.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Checkbox component allows user to select multiple items from a list
 *
 * @component
 * @example
 * ```jsx
 * <Checkbox name="radio" value="default" label="Checkbox default" checked disabled />
 * ```
 */
const Checkbox = React__namespace.forwardRef((props, ref) => {
    const { name, value, checked, disabled, className, children, readOnly, onChange = reactUtils.noop, ...restProps } = props;
    const cx = reactUtils.useStyles(Checkbox_module.default);
    const classNames = cx(className, 'container', {
        checked,
        disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'read-only': readOnly,
    });
    const controlClassNames = cx('control', {
        checked,
        disabled,
    });
    return (React__namespace.createElement("label", { "data-qa": "Checkbox", className: classNames },
        React__namespace.createElement("input", { ref: ref, className: cx('input'), type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, ...restProps }),
        React__namespace.createElement("div", { className: controlClassNames }, checked ? React__namespace.createElement(reactIcons.Check, { className: cx('icon') }) : null),
        children ? React__namespace.createElement("span", { className: cx('label') }, children) : null));
});
Checkbox.defaultProps = {
    checked: false,
};
Checkbox.displayName = 'Checkbox';

exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map
